import type { QuoteDetailsField } from 'state/quotes/details/details.model';

// WARNING: changing the order of this list will alter the display order
export const quoteDetailsFields: ReadonlyArray<QuoteDetailsField> = [
  'PricerRfqId',
  'ProductId',
  'ProductSubtype',
  'Currency',
  'NotionalAmount',
  'NotionalAmountInUnit',
  'Underlyings',
  'MaturityDate',
  'SolvingMode',
  'Strike',
  'SelectedOnBehalfClient',
  'Wrapper',
  'RecallCoupon',
  'RecallThreshold',
  'KIThreshold',
  'TradingDesk',
  'TradingPrice',
  'XMargin',
  'UpfrontFee',
  'CouponFrequency',
  'Fugit',
  'SolvedParamSensi',
  'AggressivenessRatio',
];
